var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('toastification-variant'),_c('toastification-position'),_c('toastification-icon'),_c('toastification-timeout')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }